// frontend/src/utils/axiosWithTenant.js
import axios from 'axios';

// Create axios instance with interceptors
const axiosWithTenant = axios.create({
    baseURL: '',
});

export const CancelToken = axios.CancelToken;
export const source = axios.CancelToken.source();
export const isCancel = axios.isCancel;

// Function to get hostname from browser
const getHostname = () => {
    return window.location.hostname;
};

// Request interceptor to automatically add hostname and auth token
axiosWithTenant.interceptors.request.use(
    (config) => {
        // Get hostname from browser
        const hostname = getHostname();
        if (hostname) {
            config.headers['X-Tenant-Host'] = hostname;
        }

        console.log('Sending hostname:', hostname);

        // Get auth token from localStorage
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


// Function to get tenantId from URL
// const getTenantIdFromURL = () => {
//     const urlParams = new URLSearchParams(window.location.search);
//     return urlParams.get('tenantId');
// };

// // Request interceptor to automatically add tenantId and auth token
// axiosWithTenant.interceptors.request.use(
//     (config) => {
//         // Get tenantId from URL
//         const tenantId = getTenantIdFromURL();
//         if (tenantId) {
//             config.headers['X-Tenant-ID'] = tenantId;
//         }

//         console.log(tenantId);
//         // Get auth token from localStorage
//         const token = localStorage.getItem('token');
//         if (token) {
//             config.headers.Authorization = `Bearer ${token}`;
//         }

//         return config;
//     },
//     (error) => {
//         return Promise.reject(error);
//     }
// );

// Response interceptor for error handling
axiosWithTenant.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axiosWithTenant;